module.exports = __webpack_public_path__ + "static/media/registro.46182500.png";